function finiteAmount(raw) {
  if (raw == null || String(raw).trim() === '') return null
  const n = Number(String(raw).replace(/,/g, '').trim())
  if (!Number.isFinite(n)) return null
  return n
}

/** Ledger balance from the customer-balance payload. */
export function readLedgerBalance(data) {
  if (!data || data.customer_balance_ok === false) return null
  return finiteAmount(data.ledger_balance ?? data.ledgerBalance)
}

/**
 * Available balance from credit exposure (CR_EXPOSUR).
 * SAP sends a liability as a negative amount; the screen shows the absolute value.
 */
export function readAvailableBalance(data) {
  if (!data || data.credit_exposure_ok === false) return null
  const raw =
    data.credit_exposure_balance ?? data.CR_EXPOSUR ?? data.credit_exposure
  const n = finiteAmount(raw)
  if (n == null) return null
  return Math.abs(n)
}
